import React from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  variant?: 'default' | 'overview' | 'ghg' | 'buildings' | 'transportation' | 'people' | 'other' | 'coolclimate' | 'maps';
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, variant = 'default' }) => {
  return (
    <div className={`page-header page-header-${variant}`}>
      <div className="page-header-content">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </div>
    </div>
  );
};
